import { BaseStore, getOrCreateStore } from '@Di'
import { action, observable } from 'mobx'
import { pick } from 'ramda'

export const User = pick([
  'id',
  'type',
  'username',
  'name',
  'email_confirmed',
  'avatar_url',
  'cover_url',
  'created_at',
  'updated_at',
  'email',
  'role',
  'score',
  'etc',
  'sparq3',
])

const isUser = (account) => Boolean(account && account.type === 'user')

class UsersStore extends BaseStore {
  @observable byId = observable.map()

  get collaborators() {
    const iterator = this.byId[Symbol.iterator]()
    const result = []

    // eslint-disable-next-line no-unused-vars
    for (const [_, value] of iterator) {
      result.push(value)
    }

    return result
  }

  @action
  load(data, cb) {
    const users = data.map(User)
    let models = users.map((item) => {
      let model = this.getById(item.id)
      if (!model) {
        model = observable({ ...item })
        this.byId.set(String(model.id), model)
      }
      return model
    })
    cb && cb(models)
  }

  getById(id) {
    const account = this.byId.get(String(id))
    return isUser(account) ? account : undefined
  }
}

export default getOrCreateStore('UsersStore', UsersStore)
